export const CRM_SYNC_STORE_EVENT_NAMES = [
  'flexworker-signed-up',
  'flexworker-updated',
] as const;

export type CrmSyncStoreEventName = (typeof CRM_SYNC_STORE_EVENT_NAMES)[number];
